import { Controller } from "@hotwired/stimulus"

// Spins the sync icon the moment the request leaves, then follows whatever state
// the server sends back -- the redirect after the click, or the broadcast that
// arrives when the job finishes.
export default class extends Controller {
  static targets = ["icon", "state"]
  static classes = ["spinning"]

  start() {
    this.spin(true)
  }

  // Either target can arrive first, so both re-read the state.
  stateTargetConnected() {
    this.follow()
  }

  iconTargetConnected() {
    this.follow()
  }

  follow() {
    if (!this.hasStateTarget) return

    this.spin(this.stateTarget.dataset.syncing === "true")
  }

  spin(active) {
    if (!this.hasIconTarget) return

    this.iconTarget.classList.toggle(this.spinningClass, active)
  }
}
